import type { ReactNode } from "react";
import styles from "./Segmented.module.css";

export interface SegmentedItem {
  key: string;
  label: ReactNode;
}

interface SegmentedProps {
  items: SegmentedItem[];
  value: string;
  onChange: (key: string) => void;
  size?: "sm" | "md";
}

/** Segmented control. Matches library-inputs.jsx `Segmented`. */
export function Segmented({ items, value, onChange, size = "md" }: SegmentedProps) {
  return (
    <div className={`${styles.wrap} ${styles[`s_${size}`]}`} role="tablist">
      {items.map((it) => (
        <button
          key={it.key}
          role="tab"
          aria-selected={it.key === value}
          className={`${styles.seg} ${it.key === value ? styles.active : ""}`}
          onClick={() => onChange(it.key)}
          type="button"
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
